/**
 * Helpers de clasificación de CUIT por prefijo (compartidos back/front).
 *
 * Prefijos AFIP/ARCA:
 *   - Persona física (incluye monotributistas y autónomos): 20, 23, 24, 25, 26, 27
 *   - Persona jurídica (sociedades/empresas):                30, 33, 34
 *
 * Regla del proyecto (TALAPP-1748): la CALIFICACIÓN del onboarding (PERSONA_HUMANA /
 * PERSONA_JURIDICA) NO se deriva del CUIT — se fija por el circuito elegido al registrarse
 * (`users.userType`) y es inmutable. Estos helpers se usan SOLO para VALIDAR que el CUIT
 * de una empresa sea coherente con el circuito (no para clasificar).
 */

const PREFIJOS_JURIDICA = new Set([30, 33, 34]);
const PREFIJOS_FISICA = new Set([20, 23, 24, 25, 26, 27]);

/** Devuelve el prefijo (2 primeros dígitos) del CUIT, o null si no es válido. */
export function getCuitPrefix(cuit: string | null | undefined): number | null {
  const digits = (cuit ?? "").replace(/\D/g, "");
  if (digits.length < 2) return null;
  return parseInt(digits.substring(0, 2), 10);
}

/** true si el CUIT corresponde a una persona jurídica (prefijo 30/33/34). */
export function isCuitJuridica(cuit: string | null | undefined): boolean {
  const p = getCuitPrefix(cuit);
  return p !== null && PREFIJOS_JURIDICA.has(p);
}

/** true si el CUIT corresponde a una persona física (prefijo 20/23/24/25/26/27). */
export function isCuitPersonaFisica(cuit: string | null | undefined): boolean {
  const p = getCuitPrefix(cuit);
  return p !== null && PREFIJOS_FISICA.has(p);
}
